import Vue from 'vue'

import { service } from '@/helpers/http'

/**
 * Aliases usados pelos módulos de alocação / ocupação (chamadas this.$service('occupancy_alerts.*')).
 * O cliente HTTP (services.js) exporta chaves em camelCase (ex.: roomAllocation).
 */
const SERVICE_MODULE_ALIASES = {
    occupancy_alerts: 'roomAllocation',
    occupancy_consolidations: 'roomAllocation',
}

export const appToastState = Vue.observable({
    show: false,
    message: '',
    color: 'success',
})

function openToast(color, message) {
    appToastState.color = color
    appToastState.message = message || ''
    appToastState.show = Boolean(message)
}

const MyPlugin = {
    install(VueCtor) {
        VueCtor.prototype.$toast = {
            success: (msg) => openToast('success', msg),
            error: (msg) => openToast('error', msg),
            warning: (msg) => openToast('warning', msg),
        }

        VueCtor.prototype.$service = function (qualifiedAction, payload = {}, extra = {}) {
            const dot = qualifiedAction.indexOf('.')
            if (dot === -1) {
                return Promise.reject(new Error(`$service: formato inválido "${qualifiedAction}"`))
            }
            const alias = qualifiedAction.slice(0, dot)
            const actionName = qualifiedAction.slice(dot + 1)
            const module = SERVICE_MODULE_ALIASES[alias] || alias
            return service({
                module,
                action: actionName,
                payload,
                headers: extra.headers,
            })
        }
    },
}

Vue.use(MyPlugin)

export default MyPlugin
